import React, { forwardRef } from 'react';
import { inputCls, textareaCls, inputErrorCls } from './formStyles';

// Drop-in replacements for native <input> / <select> / <textarea>.
// All native props pass through, so swapping a hand-rolled element for
// these is a one-line change. Extras:
//   - `error` (boolean): applies the error variant styling
//   - `className`: appended (not replaced) so callers can add modifiers
//
// Why forwardRef: some forms call .focus() programmatically; native ref
// passthrough keeps that working. Why no floating labels: would require
// migrating every FormField call site, which is the high-risk part we
// agreed to skip in Phase 8.

export const Input = forwardRef(function Input({ error, className = '', ...rest }, ref) {
    const cls = `${inputCls} ${error ? inputErrorCls : ''} ${className}`.trim();
    return <input ref={ref} className={cls} {...rest} />;
});

export const Select = forwardRef(function Select({ error, className = '', children, ...rest }, ref) {
    const cls = `${inputCls} ${error ? inputErrorCls : ''} ${className}`.trim();
    return <select ref={ref} className={cls} {...rest}>{children}</select>;
});

export const Textarea = forwardRef(function Textarea({ error, className = '', ...rest }, ref) {
    const cls = `${textareaCls} ${error ? inputErrorCls : ''} ${className}`.trim();
    return <textarea ref={ref} className={cls} {...rest} />;
});
